import {
  EXECUTAR_VALIDACAO_INIT_IQVIA,
  EXECUTAR_VALIDACAO_SUCCESS_IQVIA,
  EXECUTAR_VALIDACAO_ERROR_IQVIA,
  CLEAR_FLAGS_VALIDACAO_IQVIA,
  CLEAR_DADOS_VALIDACAO_IQVIA,
  BUSCA_CONSULTAS_SUCCESS_IQVIA,
  BUSCA_CONSULTAS_INIT_IQVIA
} from '../actionTypes';

const initialState = {
  loading: false,
  isFetchingDados: false,
  isFetchingConsultas: false,
  isError: false,
  msg: '',
  dados: [],
  consultas: []
};

const validacaoRelatoriosIqviaReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case EXECUTAR_VALIDACAO_INIT_IQVIA:
      return {
        ...state,
        loading: true,
        isFetchingDados: false,
        isError: false,
        msg: ''
      };
    case EXECUTAR_VALIDACAO_SUCCESS_IQVIA:
      return {
        ...state,
        loading: false,
        isFetchingDados: true,
        dados: action.payload.dados || action.payload,
        msg: action.payload.mensagem
      };
    case BUSCA_CONSULTAS_INIT_IQVIA:
      return {
        ...state,
        loading: true,
        isFetchingConsultas: false,
        isError: false,
        msg: ''
      };

    case BUSCA_CONSULTAS_SUCCESS_IQVIA:
      return {
        ...state,
        loading: false,
        isFetchingConsultas: true,
        consultas: action.payload.consultas,
        msg: action.payload.mensagem
      };
    case EXECUTAR_VALIDACAO_ERROR_IQVIA:
      return {
        ...state,
        loading: false,
        isError: true,
        msg: action.payload
      };
    case CLEAR_FLAGS_VALIDACAO_IQVIA:
      return {
        ...state,
        isFetchingDados: false,
        isError: false,
        msg: ''
      };
    case CLEAR_DADOS_VALIDACAO_IQVIA:
      return {
        ...state,
        dados: []
      };
    default:
      return state;
  }
};

export default validacaoRelatoriosIqviaReducer;
